export const FETCH_BROKERAGE_OFFER_DATA = '@@od/store/brokerageOfferFlow/fetchBrokerageOfferData';
export const BEGIN_LOADING_BROKERAGE_OFFER_DATA =
  '@@od/store/brokerageOfferFlow/beginLoadingBrokerageOfferData';
export const RECEIVE_BROKERAGE_OFFER_DATA =
  '@@od/store/brokerageOfferFlow/receiveBrokerageOfferData';
export const FETCH_OTHER_BIDS = '@@od/store/brokerageOfferFlow/fetchOtherBids';
export const RECEIVE_OTHER_BIDS_DATA = '@@od/store/brokerageOfferFlow/receiveOtherBidsData';
export const RECEIVE_INVITATION_DATA = '@@od/store/brokerageOfferFlow/receiveInvitationData';
export const UPDATE_BROKERAGE_OFFER_DETAILS =
  '@@od/store/brokerageOfferFlow/updateBrokerageOfferDetails';
export const UPDATE_PURCHASE_AGREEMENT = '@@od/store/brokerageOfferFlow/updatePurchaseAgreement';
export const SET_INVITATION_TOKEN = '@@od/store/brokerageOfferFlow/setInvitationToken';
export const STORE_INVITATION_TOKEN_FROM_LOCAL_STORAGE =
  '@@od/store/brokerageOfferFlow/storeInvitationToken';
export const BEGIN_OFFER_ACCEPT = '@@od/store/brokerageOfferFlow/beginOfferAccept';
export const MAYBE_ACCEPT_INVITATION = '@@od/store/brokerageOfferFlow/maybeAcceptInvitation';
export const ACCEPT_INVITATION = '@@od/store/brokerageOfferFlow/acceptInvitation';
export const SHOW_DECLINE_OFFER_MODAL = '@@od/store/brokerageOfferFlow/showOfferDeclineModal';
export const HIDE_DECLINE_OFFER_MODAL = '@@od/store/brokerageOfferFlow/hideOfferDeclineModal';
export const CREATE_NEW_USER_ACCOUNT = '@@od/store/brokerageOfferFlow/createNewUserAccount';
export const HANDLE_RETURNING_USER = '@@od/store/brokerageOfferFlow/handleReturningUser';
export const ON_DECLINE_SUBMIT = '@@od/store/brokerageOfferFlow/onDeclineSubmit';
export const SET_NEW_OFFER_REQUESTED = '@@od/store/brokerageOfferFlow/setNewOfferRequested';
export const REQUEST_NEW_OFFER = '@@od/store/brokerageOfferFlow/requestNewOffer';
export const REDIRECT_TO_ERROR = '@@od/store/brokerageOfferFlow/redirectToError';
export const LOGIN_ERROR = '@@od/store/brokerageOfferFlow/loginError';
export const SUBMIT_PURCHASE_AGREEMENT = '@@od/store/brokerageOfferFlow/submitPurchaseAgreement';
export const REDIRECT_TO_COMPLETE = '@@od/store/brokerageOfferFlow/redirectToComplete';
